




















import BaseComponent from '../base/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ErrorDialog extends BaseComponent {

  @Prop(String) public dialogPreTitle!: string;
  @Prop(String) public dialogBodyTitle!: string;
  @Prop(String) public dialogBodyContent!: string;
  @Prop(Boolean) public errorDialogProp!: boolean;

  public errorDialog: boolean = false;
  public preTitle: string = '';
  public bodyTitle: string = '';
  public bodyContent: string = '';

  public mounted() {
    this.preTitle = this.dialogPreTitle || 'errors.error.pre_title';
    this.bodyTitle = this.dialogBodyTitle || 'errors.error.body_title';
    this.bodyContent = this.dialogBodyContent || 'errors.error.body_content';
    this.errorDialog = this.errorDialogProp;
  }

  public closeDialog() {
    this.errorDialog = false;
    this.$emit('dialogClosed');
  }

}
